module.exports = __webpack_public_path__ + "static/media/virbac_20210421.73923e7b.pdf";